"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../constants");

require("./SkipLinks.css");

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !_construct.default) return false;
    if (_construct.default.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call((0, _construct.default)(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = (0, _construct.default)(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

var SKIP_LINKS_CONFIG = [{
  text: 'Skip to main content',
  targetSelector: '#main-content'
}, {
  text: 'Skip to search',
  targetSelector: {
    desktop: '.uigSrchTxtField',
    tablet: '.uig-sub-nav-wrapper .uig-single-srch-icon-container',
    mobile: '.uig-sub-nav-mobile-wrapper .uig-single-srch-icon-container'
  }
}, {
  text: 'Skip to footer',
  targetSelector: '#page-footer'
}]; //in milliseconds

var RESIZE_DEBOUNCE_DELAY = 100;

var SkipLinks = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SkipLinks, _Component);

  var _super = _createSuper2(SkipLinks);

  function SkipLinks(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SkipLinks);
    _this = _super.call(this, props);
    _this.state = {
      active: false,
      skipLinks: [].concat(SKIP_LINKS_CONFIG)
    };
    _this.screenSize = 'desktop';
    _this.onFocus = _this.onFocus.bind((0, _assertThisInitialized2.default)(_this));
    _this.onBlur = _this.onBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.goToTarget = _this.goToTarget.bind((0, _assertThisInitialized2.default)(_this));
    _this.filter = _this.filter.bind((0, _assertThisInitialized2.default)(_this));
    _this.getTarget = _this.getTarget.bind((0, _assertThisInitialized2.default)(_this));
    _this.identifyScreenSize = _this.identifyScreenSize.bind((0, _assertThisInitialized2.default)(_this));
    _this.update = _this.update.bind((0, _assertThisInitialized2.default)(_this));
    _this.getWrapperClasses = _this.getWrapperClasses.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(SkipLinks, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.update();

      if (typeof window !== 'undefined') {
        window.addEventListener('resize', this.debounce(this.update, RESIZE_DEBOUNCE_DELAY));
      }
    }
    /**
     * Updates the skip links based on whether their target is valid
     * Those with missing targets in the DOM won't be rendered
     */

  }, {
    key: "filter",
    value: function filter() {
      var skipLinks = [];

      for (var idx = 0; idx < SKIP_LINKS_CONFIG.length; idx++) {
        var skipLink = SKIP_LINKS_CONFIG[idx];
        var target = this.getTarget(skipLink.targetSelector);

        if (target) {
          skipLinks.push(skipLink);
        }
      }

      this.setState({
        skipLinks: skipLinks
      });
    }
    /**
     * @description
     * Returns the target depending on the screen size
     * @param {String} targetSelector The skip link target selector
     * @returns {HTMLElement} The hmtl target element
     */

  }, {
    key: "getTarget",
    value: function getTarget(targetSelector) {
      if (targetSelector && (0, _typeof2.default)(targetSelector) === 'object') {
        targetSelector = targetSelector[this.screenSize];
      }

      var target = typeof document !== 'undefined' && document.querySelector(targetSelector);
      var isTargetVisible = target && target.offsetParent !== null;
      return isTargetVisible ? target : null;
    }
    /**
     * @description
     * Changes the screen size {'mobile'|'desktop'|'tablet'} based on the window width
     * Used for changing the skip links targets (if they are different on some window sizes)
     */

  }, {
    key: "identifyScreenSize",
    value: function identifyScreenSize() {
      var isNotDesktop = typeof window !== 'undefined' ? window.matchMedia('(max-width: 1199px)') : {
        matches: false
      };
      var isMobile = typeof window !== 'undefined' ? window.matchMedia('(max-width: 767px') : {
        matches: false
      };
      var screenSize = 'desktop';

      if (isNotDesktop.matches) {
        if (isMobile.matches) {
          screenSize = 'mobile';
        } else {
          screenSize = 'tablet';
        }
      }

      this.screenSize = screenSize;
    }
    /**
     * @description
     * Updates the skip links rendered on the page based on the screen size
     */

  }, {
    key: "update",
    value: function update() {
      this.identifyScreenSize();
      this.filter();
    }
    /**
     * @description 
     * Debounces function with the delay amount 
     * @param {Function} func The function to be debounced
     * @param {Number} delay The delay in milliseconds
     * @returns {Function} The debounced function
     */

  }, {
    key: "debounce",
    value: function debounce(func, delay) {
      var debounce;
      return function () {
        clearTimeout(debounce);
        debounce = setTimeout(function () {
          return func();
        }, delay);
      };
    }
    /**
     * @description
     * Link focus event handler
     * Makes the skip link container visible if it's not
     */

  }, {
    key: "onFocus",
    value: function onFocus() {
      if (!this.state.active) {
        this.setState({
          active: true
        });
      }
    }
    /**
     * @description
     * Link blur event handler
     * Hides the skip link container if the focus is leaving the it
     * @param {Event} e The blur event
     */

  }, {
    key: "onBlur",
    value: function onBlur(e) {
      var isSkipLinkFocusedNext = e.relatedTarget && e.relatedTarget.classList.contains('skip-link');

      if (this.state.active && !isSkipLinkFocusedNext) {
        this.setState({
          active: false
        });
      }
    }
    /**
     * @description 
     * Scrolls into the target element and focuses it
     * @param {String} target The skip link target
     */

  }, {
    key: "goToTarget",
    value: function goToTarget(targetSelector) {
      var target = this.getTarget(targetSelector);

      if (!target) {
        return;
      }

      if (!target.getAttribute('tabindex')) {
        target.setAttribute('tabindex', -1);
        target.addEventListener('blur', function (e) {
          target.removeAttribute('tabindex');
        });
      }

      target.focus();

      if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        if ('scrollBehavior' in document.documentElement.style) {
          window.scrollTo({
            top: target.offsetTop - 60,
            behavior: 'smooth'
          });
        } else {
          window.scrollTo(0, target.offsetTop - 60);
        }
      }
    }
    /**
     * @description
     * Returns the skip links wrapper classes based on the active state and brand type
     * @returns {String} The skip links wrapper classes
     */

  }, {
    key: "getWrapperClasses",
    value: function getWrapperClasses() {
      var wrapperClasses = ['skip-links-wrapper'];

      if (this.state.active) {
        wrapperClasses.push('active');
      }

      if (this.props.brandType === _constants.BRANDS.SHUTTERFLY) {
        wrapperClasses.push('sfly');
      } else if (this.props.brandType === _constants.BRANDS.TINYPRINTS) {
        wrapperClasses.push('tp');
      }

      return wrapperClasses.join(' ');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.state.skipLinks.length < 1) {
        return null;
      }

      return _react.default.createElement("nav", {
        "aria-label": "Skip links",
        className: this.getWrapperClasses()
      }, _react.default.createElement("ul", {
        className: "skip-links-list"
      }, this.state.skipLinks.map(function (skipLink) {
        return _react.default.createElement("li", {
          className: "skip-link-wrapper",
          key: skipLink.text
        }, _react.default.createElement("a", {
          className: "skip-link",
          href: "javascript:void(0)",
          onFocus: _this2.onFocus,
          onBlur: _this2.onBlur,
          onClick: function onClick(e) {
            e.preventDefault();

            _this2.goToTarget(skipLink.targetSelector);
          }
        }, skipLink.text));
      })));
    }
  }]);
  return SkipLinks;
}(_react.Component);

SkipLinks.propTypes = {
  brandType: _propTypes.default.string
};
SkipLinks.defaultProps = {
  brandType: _constants.BRANDS.SHUTTERFLY
};
var _default = SkipLinks;
exports.default = _default;